const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  name: 'c=>c.Name',
}

export const mapSortCompanyParam = (key: string) => mapping[key]
